module.exports = __webpack_public_path__ + "073750f9703fddb72a3e53434d03f4d2.png";